var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from "graphql-tag";
import { graphql } from "react-apollo";
// TODO: Add another query that finds only user specific owned addresses (ensure addresses returned are only those owned by current user for this)
// finds all addresses submitted by ALL users
export var findInvoicesQuery = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query FindInvoicesQuery {\n    findInvoices {\n      id\n      invoice\n      expected_msatoshi\n      expected_description\n      created\n      paid\n      paidTime\n      userId\n      payRef\n      owner {\n        id\n        email\n      }\n    }\n  }\n"], ["\n  query FindInvoicesQuery {\n    findInvoices {\n      id\n      invoice\n      expected_msatoshi\n      expected_description\n      created\n      paid\n      paidTime\n      userId\n      payRef\n      owner {\n        id\n        email\n      }\n    }\n  }\n"])));
// export HOC
export var withFindInvoices = graphql(findInvoicesQuery, {
    props: function (_a) {
        var data = _a.data;
        var invoices = [];
        if (data && !data.loading && data.findInvoices) {
            invoices = data.findInvoices;
        }
        return {
            invoices: invoices,
            // if data exists return data otherwise return false
            loading: data ? data.loading : false,
        };
    },
});
var templateObject_1;
//# sourceMappingURL=index.js.map